export const defaultSortableOption = {
    sortField: 'id',
    sortDirection: 'ASC'
};
